const translations = {
  en: {
    appTitle: 'PANTASS',
    appSubtitle: 'Tug of War: Mathematics',
    play: 'Play',
    leaderboard: 'Leaderboard',
    team1: 'Team 1',
    team2: 'Team 2',
    teamName: 'Team Name',
    score: 'Score',
    timer: 'Time',
    easy: 'Easy',
    medium: 'Medium',
    difficulty: 'Difficulty',
    operations: 'Operations',
    addition: 'Addition',
    subtraction: 'Subtraction',
    multiplication: 'Multiplication',
    division: 'Division',
    startGame: 'Start Game',
    duration: 'Round Duration',
    seconds: 'seconds',
    winner: 'Winner',
    draw: "It's a Draw!",
    wins: 'WINS!',
    playAgain: 'Play Again',
    backToHome: 'Back to Home',
    gameSetup: 'Game Setup',
    recentMatches: 'Recent Matches',
    topTeams: 'Top Teams',
    correct: 'Correct',
    wrong: 'Wrong',
    accuracy: 'Accuracy',
    go: 'GO!',
    timesUp: "Time's Up!",
    gameOver: 'Game Over',
    vs: 'VS',
    noMatches: 'No matches yet. Play your first game!',
    noLeaderboard: 'No leaderboard data yet.',
    clear: 'Clear',
    submit: 'Submit',
    enterTeamName: 'Enter team name',
    schoolName: 'School / Institution',
    enterSchoolName: 'e.g. SK Taman Melawati',
    schoolRanking: 'Schools',
    noSchools: 'No school data yet. Play a game and enter your school name!',
    totalMatchesShort: 'Matches',
    totalCorrectShort: 'Correct',
    selectDifficulty: 'Select difficulty level',
    selectOperations: 'Choose math operations',
    selectDuration: 'Choose round duration',
    winsCount: 'Wins',
    totalScore: 'Total Score',
    rank: 'Rank',
    team: 'Team',
    result: 'Result',
    date: 'Date',
    ageGroup57: 'Ages 5-7',
    ageGroup710: 'Ages 7-10',
    hard: 'Hard',
    primaryLower: 'Primary (Std 1-3)',
    primaryUpper: 'Primary (Std 4-6)',
    secondary: 'Secondary (Form 1-3)',
    month: 'month',

    // Dashboard
    dashboard: 'Dashboard',
    dashboardTitle: 'Tug of War Games by Subject',
    dashboardDesc: 'Each subject has its own tug of war game. Choose a subject and start playing!',
    comingSoon: 'Coming Soon',

    // Subjects
    subjectMath: 'Mathematics',
    subjectMathDesc: 'Quick calculations, addition, subtraction, multiplication & division.',
    subjectBM: 'Bahasa Melayu',
    subjectBMDesc: 'Grammar, vocabulary and fun language exercises.',
    subjectEN: 'English',
    subjectENDesc: 'Grammar, vocabulary and conversation practice.',
    subjectScience: 'Science',
    subjectScienceDesc: 'Atoms, molecules, reactions and experiments.',
    subjectHistory: 'History',
    subjectHistoryDesc: 'Ancient events, historical figures and culture.',
    subjectGeography: 'Geography',
    subjectGeographyDesc: 'Countries, cities and natural wonders.',
    subjectIT: 'Computer Science',
    subjectITDesc: 'Programming, algorithms and technology.',
    subjectBiology: 'Biology',
    subjectBiologyDesc: 'Anatomy, plants and ecology questions.',

    // Pricing
    pricing: 'Pricing',
    pricingTitle: 'Choose the right plan for your learning journey',
    pricingDesc: 'Each plan is designed to match your needs. Start with unlimited features or specific limits.',
    pricingH1: 'Game limits & unlimited modes',
    pricingH2: 'Save & export progress',
    pricingH3: '24/7 support & updates',
    planFree: 'Free',
    planBasic: 'Basic',
    planPro: 'Pro',
    planSchool: 'School',
    popular: 'Most Popular',
    bestValue: 'Best Value',
    startFree: 'Start Free',
    subscribe: 'Subscribe',
    contactUs: 'Contact Us',
    monthly: 'Monthly',
    annual: 'Annual',
    save20: 'Save 20%',
    perStudent: '= RM3.98/student/month (50 students)',
    pf1_free: '25 games per month',
    pf2_free: '2 subjects only',
    pf3_free: 'Easy difficulty only',
    pf4_free: 'World Leaderboard access',
    pf5_free: 'Progress tracking',
    pf6_free: 'PDF reports',
    pf1_basic: 'Unlimited games',
    pf2_basic: 'All 8 subjects',
    pf3_basic: 'Easy & Medium difficulty',
    pf4_basic: 'Full leaderboard access',
    pf5_basic: 'Progress tracking & achievements',
    pf6_basic: 'PDF reports & class tools',
    pf1_pro: 'Everything in Basic',
    pf2_pro: 'All difficulty levels (incl. Secondary)',
    pf3_pro: 'Export PDF reports',
    pf4_pro: 'Class management tools',
    pf5_pro: 'Priority support',
    pf6_pro: 'Custom team themes',
    pf1_school: 'Everything in Pro',
    pf2_school: 'Up to 50+ students',
    pf3_school: 'School branding on leaderboard',
    pf4_school: 'Teacher admin dashboard',
    pf5_school: 'Bulk student progress reports',
    pf6_school: 'Inter-class tournaments',
    pf7_school: 'Dedicated support & training',

    // Practice Mode
    practiceMode: 'Practice Mode',
    practiceSetup: 'Practice Setup',
    playerName: 'Player Name',
    enterName: 'Enter your name',
    startPractice: 'Start Practice',
    chooseSubject: 'Choose Subject',
    bestStreak: 'Best Streak',
    shareWhatsApp: 'Share to WhatsApp',

    // Auth
    loginTitle: 'Welcome Back',
    loginSubtitle: 'Log in to continue your learning journey',
    registerTitle: 'Create Account',
    registerSubtitle: 'Join PANTASS and start learning!',
    email: 'Email',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Min 6 characters',
    nameLabel: 'Full Name',
    namePlaceholder: 'Your name',
    loginBtn: 'Log In',
    registerBtn: 'Sign Up',
    logoutBtn: 'Log Out',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    skipLogin: 'Continue as guest',
    optional: 'optional',
    loginWithGoogle: 'Continue with Google',
    signUpWithGoogle: 'Sign up with Google',
    orLoginWith: 'or log in with email',
    orRegisterWith: 'or register with email',

    // Plan enforcement
    upgradeRequired: 'Upgrade Required',
    upgradeDesc: 'To access {feature}, please upgrade to {plan} plan.',
    viewPlans: 'View Plans',
    maybeLater: 'Maybe Later',
    upgradeToUnlock: 'Upgrade to unlock',
    gamesUsed: 'Games this month',
    limitReached: 'Limit reached! Upgrade for unlimited.',
    unlimitedGames: 'unlimited games',
    currentPlan: 'Current Plan',
    managePlan: 'Manage Plan',
    verifyingPayment: 'Verifying payment...',
    paymentSuccess: 'Payment Successful!',
    upgradedTo: 'Your plan has been upgraded to',
    paymentPending: 'Payment is being processed...',
    paymentError: 'Payment verification failed',
    tryAgain: 'Try Again',

    // Forgot Password
    forgotPassword: 'Forgot Password?',
    forgotPasswordDesc: 'Enter your email and we will send you a reset code.',
    sendCode: 'Send Reset Code',
    backToLogin: 'Back to Login',
    resetPassword: 'Reset Password',
    enterCodeDesc: 'Enter the 6-digit code and your new password.',
    resetCode: 'Reset Code',
    newPassword: 'New Password',
    resetPasswordBtn: 'Reset Password',
    passwordResetSuccess: 'Password Reset!',
    passwordResetSuccessDesc: 'Your password has been updated. You can now log in.',

    // Class Management
    classManagement: 'My Classes',
    yourClasses: 'Your Classes',
    classesDesc: 'Create and manage your classes. Track student progress and export reports.',
    createClass: 'Create Class',
    classNamePlaceholder: 'e.g. 3 Bestari',
    create: 'Create',
    cancel: 'Cancel',
    noClasses: 'No classes yet. Create your first class!',
    studentsCount: 'students',
    confirmDelete: 'Are you sure you want to delete this class?',
    classDetail: 'Class Detail',
    addStudent: 'Add',
    addStudentPlaceholder: 'Student name',
    studentName: 'Student',
    totalGames: 'Games',
    noStudents: 'No students added yet. Add students to track their progress!',
    exportClassReport: 'Export Class Report (PDF)',
    backToClasses: 'Back to Classes',
    classReport: 'Class Report',
    className: 'Class',

    // Tournaments
    tournaments: 'Tournaments',
    tournamentsTitle: 'Inter-Class Tournaments',
    tournamentsDesc: 'Create bracket-style tournaments between classes or teams.',
    createTournament: 'Create Tournament',
    tournamentNamePlaceholder: 'e.g. Math Championship 2026',
    enterTeamsOnePerLine: 'Enter team names (one per line):',
    teamsAdded: 'teams added',
    noTournaments: 'No tournaments yet. Create your first tournament!',
    teamsLabel: 'teams',
    champion: 'Champion',
    completed: 'Completed',
    active: 'Active',
    final: 'Final',
    semiFinal: 'Semi-Final',
    quarterFinal: 'Quarter-Final',
    round: 'Round',
    tapToRecord: 'Tap to record result',
    recordResult: 'Record Match Result',
    saveResult: 'Save Result',
    backToTournaments: 'Back to Tournaments',

    // Dashboard/Stats
    progressDashboard: 'Progress',
    totalMatches: 'Total Matches',
    avgAccuracy: 'Avg Accuracy',
    bestStreakLabel: 'Best Streak',
    totalCorrect: 'Total Correct',
    achievementsTitle: 'Achievements',
    exportPDF: 'Export PDF Report',
  },
  bm: {
    appTitle: 'PANTASS',
    appSubtitle: 'Tarik Tali: Matematik',
    play: 'Mula',
    leaderboard: 'Papan Markah',
    team1: 'Pasukan 1',
    team2: 'Pasukan 2',
    teamName: 'Nama Pasukan',
    score: 'Markah',
    timer: 'Masa',
    easy: 'Mudah',
    medium: 'Sederhana',
    difficulty: 'Tahap',
    operations: 'Operasi',
    addition: 'Tambah',
    subtraction: 'Tolak',
    multiplication: 'Darab',
    division: 'Bahagi',
    startGame: 'Mula Permainan',
    duration: 'Tempoh Pusingan',
    seconds: 'saat',
    winner: 'Pemenang',
    draw: 'Seri!',
    wins: 'MENANG!',
    playAgain: 'Main Lagi',
    backToHome: 'Kembali',
    gameSetup: 'Tetapan Permainan',
    recentMatches: 'Perlawanan Terbaru',
    topTeams: 'Pasukan Terbaik',
    correct: 'Betul',
    wrong: 'Salah',
    accuracy: 'Ketepatan',
    go: 'MULA!',
    timesUp: 'Masa Tamat!',
    gameOver: 'Tamat',
    vs: 'LAWAN',
    noMatches: 'Tiada perlawanan lagi. Mula permainan pertama!',
    noLeaderboard: 'Tiada data papan markah lagi.',
    clear: 'Padam',
    submit: 'Hantar',
    enterTeamName: 'Masukkan nama pasukan',
    schoolName: 'Sekolah / Institusi',
    enterSchoolName: 'cth. SK Taman Melawati',
    schoolRanking: 'Sekolah',
    noSchools: 'Tiada data sekolah lagi. Main game dan masukkan nama sekolah!',
    totalMatchesShort: 'Perlawanan',
    totalCorrectShort: 'Betul',
    selectDifficulty: 'Pilih tahap kesukaran',
    selectOperations: 'Pilih operasi matematik',
    selectDuration: 'Pilih tempoh pusingan',
    winsCount: 'Menang',
    totalScore: 'Jumlah Markah',
    rank: 'Kedudukan',
    team: 'Pasukan',
    result: 'Keputusan',
    date: 'Tarikh',
    ageGroup57: 'Umur 5-7',
    ageGroup710: 'Umur 7-10',
    hard: 'Sukar',
    primaryLower: 'Rendah (Drjh 1-3)',
    primaryUpper: 'Rendah (Drjh 4-6)',
    secondary: 'Menengah (Ting 1-3)',
    month: 'bulan',

    // Dashboard
    dashboard: 'Dashboard',
    dashboardTitle: 'Permainan Tarik Tali mengikut Subjek',
    dashboardDesc: 'Setiap subjek mempunyai permainan tarik tali sendiri. Pilih subjek dan mula bermain!',
    comingSoon: 'Akan Datang',

    // Subjects
    subjectMath: 'Matematik',
    subjectMathDesc: 'Pengiraan pantas, tambah, tolak, darab & bahagi.',
    subjectBM: 'Bahasa Melayu',
    subjectBMDesc: 'Tatabahasa, perbendaharaan kata dan latihan bahasa.',
    subjectEN: 'Bahasa Inggeris',
    subjectENDesc: 'Grammar, vocabulary dan latihan perbualan.',
    subjectScience: 'Sains',
    subjectScienceDesc: 'Atom, molekul, tindak balas dan eksperimen.',
    subjectHistory: 'Sejarah',
    subjectHistoryDesc: 'Peristiwa silam, tokoh sejarah dan budaya.',
    subjectGeography: 'Geografi',
    subjectGeographyDesc: 'Negara, bandar dan keajaiban alam.',
    subjectIT: 'Sains Komputer',
    subjectITDesc: 'Pengaturcaraan, algoritma dan teknologi.',
    subjectBiology: 'Biologi',
    subjectBiologyDesc: 'Anatomi, tumbuhan dan soalan ekologi.',

    // Pricing
    pricing: 'Harga',
    pricingTitle: 'Pilih pelan yang sesuai untuk pembelajaran anda',
    pricingDesc: 'Setiap pelan direka untuk memenuhi keperluan anda. Mula dengan ciri tanpa had atau had tertentu.',
    pricingH1: 'Had permainan & mod tanpa had',
    pricingH2: 'Simpan & eksport kemajuan',
    pricingH3: 'Sokongan 24/7 & kemas kini',
    planFree: 'Percuma',
    planBasic: 'Asas',
    planPro: 'Pro',
    planSchool: 'Sekolah',
    popular: 'Paling Popular',
    bestValue: 'Nilai Terbaik',
    startFree: 'Mula Percuma',
    subscribe: 'Langgan',
    contactUs: 'Hubungi Kami',
    monthly: 'Bulanan',
    annual: 'Tahunan',
    save20: 'Jimat 20%',
    perStudent: '= RM3.98/pelajar/bulan (50 pelajar)',
    pf1_free: '25 permainan sebulan',
    pf2_free: '2 subjek sahaja',
    pf3_free: 'Tahap Mudah sahaja',
    pf4_free: 'Akses Papan Markah Dunia',
    pf5_free: 'Penjejakan kemajuan',
    pf6_free: 'Laporan PDF',
    pf1_basic: 'Permainan tanpa had',
    pf2_basic: 'Semua 8 subjek',
    pf3_basic: 'Tahap Mudah & Sederhana',
    pf4_basic: 'Akses penuh papan markah',
    pf5_basic: 'Penjejakan kemajuan & pencapaian',
    pf6_basic: 'Laporan PDF & alat kelas',
    pf1_pro: 'Semua dalam Asas',
    pf2_pro: 'Semua tahap (termasuk Menengah)',
    pf3_pro: 'Eksport laporan PDF',
    pf4_pro: 'Alat pengurusan kelas',
    pf5_pro: 'Sokongan keutamaan',
    pf6_pro: 'Tema pasukan tersuai',
    pf1_school: 'Semua dalam Pro',
    pf2_school: 'Sehingga 50+ pelajar',
    pf3_school: 'Branding sekolah di papan markah',
    pf4_school: 'Dashboard admin guru',
    pf5_school: 'Laporan kemajuan pukal',
    pf6_school: 'Pertandingan antara kelas',
    pf7_school: 'Sokongan & latihan khusus',

    // Practice Mode
    practiceMode: 'Mod Latihan',
    practiceSetup: 'Tetapan Latihan',
    playerName: 'Nama Pemain',
    enterName: 'Masukkan nama anda',
    startPractice: 'Mula Latihan',
    chooseSubject: 'Pilih Subjek',
    bestStreak: 'Kombo Terbaik',
    shareWhatsApp: 'Kongsi ke WhatsApp',

    // Auth
    loginTitle: 'Selamat Kembali',
    loginSubtitle: 'Log masuk untuk teruskan pembelajaran',
    registerTitle: 'Buat Akaun',
    registerSubtitle: 'Sertai PANTASS dan mula belajar!',
    email: 'E-mel',
    passwordLabel: 'Kata Laluan',
    passwordPlaceholder: 'Min 6 aksara',
    nameLabel: 'Nama Penuh',
    namePlaceholder: 'Nama anda',
    loginBtn: 'Log Masuk',
    registerBtn: 'Daftar',
    logoutBtn: 'Log Keluar',
    noAccount: 'Belum ada akaun?',
    haveAccount: 'Sudah ada akaun?',
    skipLogin: 'Teruskan sebagai tetamu',
    optional: 'pilihan',
    loginWithGoogle: 'Teruskan dengan Google',
    signUpWithGoogle: 'Daftar dengan Google',
    orLoginWith: 'atau log masuk dengan e-mel',
    orRegisterWith: 'atau daftar dengan e-mel',

    // Plan enforcement
    upgradeRequired: 'Perlu Naik Taraf',
    upgradeDesc: 'Untuk akses {feature}, sila naik taraf ke pelan {plan}.',
    viewPlans: 'Lihat Pelan',
    maybeLater: 'Nanti Dulu',
    upgradeToUnlock: 'Naik taraf untuk buka',
    gamesUsed: 'Permainan bulan ini',
    limitReached: 'Had dicapai! Naik taraf untuk tanpa had.',
    unlimitedGames: 'permainan tanpa had',
    currentPlan: 'Pelan Semasa',
    managePlan: 'Urus Pelan',
    verifyingPayment: 'Mengesahkan pembayaran...',
    paymentSuccess: 'Pembayaran Berjaya!',
    upgradedTo: 'Pelan anda telah dinaik taraf ke',
    paymentPending: 'Pembayaran sedang diproses...',
    paymentError: 'Pengesahan pembayaran gagal',
    tryAgain: 'Cuba Lagi',

    // Forgot Password
    forgotPassword: 'Lupa Kata Laluan?',
    forgotPasswordDesc: 'Masukkan e-mel anda dan kami akan hantar kod tetapan semula.',
    sendCode: 'Hantar Kod',
    backToLogin: 'Kembali ke Log Masuk',
    resetPassword: 'Tetap Semula Kata Laluan',
    enterCodeDesc: 'Masukkan kod 6 digit dan kata laluan baru anda.',
    resetCode: 'Kod Tetapan Semula',
    newPassword: 'Kata Laluan Baru',
    resetPasswordBtn: 'Tetap Semula',
    passwordResetSuccess: 'Kata Laluan Ditetapkan Semula!',
    passwordResetSuccessDesc: 'Kata laluan anda telah dikemas kini. Anda boleh log masuk sekarang.',

    // Class Management
    classManagement: 'Kelas Saya',
    yourClasses: 'Kelas Anda',
    classesDesc: 'Buat dan urus kelas anda. Jejak kemajuan pelajar dan eksport laporan.',
    createClass: 'Buat Kelas',
    classNamePlaceholder: 'cth. 3 Bestari',
    create: 'Buat',
    cancel: 'Batal',
    noClasses: 'Tiada kelas lagi. Buat kelas pertama anda!',
    studentsCount: 'pelajar',
    confirmDelete: 'Anda pasti mahu padam kelas ini?',
    classDetail: 'Butiran Kelas',
    addStudent: 'Tambah',
    addStudentPlaceholder: 'Nama pelajar',
    studentName: 'Pelajar',
    totalGames: 'Permainan',
    noStudents: 'Tiada pelajar lagi. Tambah pelajar untuk jejak kemajuan mereka!',
    exportClassReport: 'Eksport Laporan Kelas (PDF)',
    backToClasses: 'Kembali ke Kelas',
    classReport: 'Laporan Kelas',
    className: 'Kelas',

    // Tournaments
    tournaments: 'Pertandingan',
    tournamentsTitle: 'Pertandingan Antara Kelas',
    tournamentsDesc: 'Buat pertandingan bracket antara kelas atau pasukan.',
    createTournament: 'Buat Pertandingan',
    tournamentNamePlaceholder: 'cth. Kejohanan Matematik 2026',
    enterTeamsOnePerLine: 'Masukkan nama pasukan (satu setiap baris):',
    teamsAdded: 'pasukan ditambah',
    noTournaments: 'Tiada pertandingan lagi. Buat pertandingan pertama!',
    teamsLabel: 'pasukan',
    champion: 'Juara',
    completed: 'Selesai',
    active: 'Aktif',
    final: 'Final',
    semiFinal: 'Separuh Akhir',
    quarterFinal: 'Suku Akhir',
    round: 'Pusingan',
    tapToRecord: 'Tekan untuk rekod keputusan',
    recordResult: 'Rekod Keputusan Perlawanan',
    saveResult: 'Simpan Keputusan',
    backToTournaments: 'Kembali ke Pertandingan',

    // Dashboard/Stats
    progressDashboard: 'Kemajuan',
    totalMatches: 'Jumlah Perlawanan',
    avgAccuracy: 'Ketepatan Purata',
    bestStreakLabel: 'Kombo Terbaik',
    totalCorrect: 'Jumlah Betul',
    achievementsTitle: 'Pencapaian',
    exportPDF: 'Eksport Laporan PDF',
  }
};

export function t(key, language = 'en') {
  return translations[language]?.[key] || translations['en']?.[key] || key;
}

export default translations;
